import React, { useContext } from "react";
import OutputSummaryTable from "../components/OutputSummaryTable";
import PermitStatus from "../components/PermitStatus";
import SoilSummary from "../components/SoilSummary";
import { General } from "../tools/styles";
import SedimentSummary from "../components/SedimentSummary";
import OverallStatus from "../components/OverallStatus";
import { WatchContext } from "../WatchContext";
import GenerateReport from "../components/GenerateReport";
import Progress from "../components/Progress";
import FloatCard from "../components/ui/FloatCard";
import WaterSummary from "../components/WaterSummary";

const Output = () => {
  let { horizontal, vertical, hydrology, biology } = useContext(WatchContext);

  let compArray = [
    <OutputSummaryTable />,
    <SedimentSummary />,
    <SoilSummary />,
    <WaterSummary />,
    <PermitStatus />,
  ];

  let floatCardEls = compArray.map((item, i) => (
    <FloatCard key={i} margin="2rem" width="95%">
      {item}
    </FloatCard>
  ));

  return (
    <General.ColBlock margin="2rem">
      <h2 style={{ margin: "2rem" }}>Output</h2>
      <div style={{ display: "flex", margin: "1rem" }}>
        <div
          style={{ display: "flex", flexDirection: "column", height: "100%" }}
        >
          <OverallStatus />

          <GenerateReport />
        </div>

        <div>
          <Progress data={horizontal} />
          <Progress data={vertical} />
          <Progress data={biology} />
          <Progress data={hydrology} />
        </div>
      </div>
      {floatCardEls}
    </General.ColBlock>
  );
};

export default Output;
